import styled from "styled-components";
import chiemgau from "../../../images/chiemgau.jpg";
import kochel from "../../../images/immobilien/kochel.jpg";
import benediktbeuern from "../../../images/immobilien/benediktbeuern.webp";
import wohnung from "../../../images/immobilien/wohnung.jpg";
import laax from "../../../images/immobilien/laax.webp";
import grundKochelZusammen from "../../../images/immobilien/grundKochelZusammen.jpeg";
import kaffeemuehlenVilla from "../../../images/immobilien/kaffehausvilla.jpg";
import heroVideo from "../../../videos/kochel2.mp4";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const Hero = styled.section`
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 700px;
    overflow: hidden;
    display: flex;
    align-items: flex-end;

    @supports (height: 100dvh) {
        height: 100dvh;
    }
`;

const HeroVideo = styled.video`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Overlay = styled.div`
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,.35);
`;

const HeroContent = styled.div`
    position: relative;
    z-index: 2;
    width: min(1200px, 90%);
    margin: 0 auto;
    color: white;

    padding-bottom: 120px;
`;

const HeroTitle = styled.h1`
    font-size: clamp(3rem, 6vw, 5rem);
    font-weight: 300;
    letter-spacing: 3px;
    line-height: 1.1;
    margin-bottom: 24px;
    max-width: 700px;
`;

const Section = styled.section`
    padding: 110px 24px;
`;

const AboutSection = styled(Section)`
    background: #f7f7f7;
`;

const Wrapper = styled.div`
    width: min(1200px, 100%);
    margin: 0 auto;
`;

const SectionTitle = styled.h2`
    text-align: center;
    font-size: 2.8rem;
    font-weight: 300;
    margin-bottom: 70px;
    letter-spacing: 2px;
`;

const AboutText = styled.div`
    max-width: 760px;
    margin: 0 auto;
    text-align: left;

    p{
        font-size: 1.15rem;
        line-height: 2;
        color: #444;
        margin-bottom: 28px;
    }
`;

const PropertyGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 36px;

    @media (max-width: 1000px){
        grid-template-columns: repeat(2,1fr);
    }

    @media (max-width: 650px){
        grid-template-columns: 1fr;
    }
`;

const PropertyCard = styled.a`
    display: block;
    color: inherit;
    text-decoration: none;
    background: white;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 10px 35px rgba(0,0,0,.08);
    transition: .35s ease;
    cursor: pointer;

    &:hover{
        transform: translateY(-8px);
        box-shadow: 0 18px 45px rgba(0,0,0,.15);
    }
`;

const ImageWrapper = styled.div`
    overflow: hidden;
    height: 260px;
`;

const PropertyImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform .5s ease;

    ${PropertyCard}:hover &{
        transform: scale(1.06);
    }
`;

const CardContent = styled.div`
    padding: 24px;
`;

const CardTitle = styled.h3`
    margin: 0 0 10px;
    font-size: 1.3rem;
    font-weight: 500;
`;

const CardText = styled.p`
    color: #666;
    line-height: 1.7;
    font-size: .95rem;
`;

const CTAWrapper = styled.div`
    margin-top: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const CTAStyledLink = styled(Link)`
    position: relative;

    text-decoration: none;

    color: ${({ $scrolled }) =>
        $scrolled ? "#222" : "white"};

    font-size: .92rem;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;

    transition: color .3s ease;

    &::after{
        content:"";
        position:absolute;
        left:0;
        bottom:-8px;

        width:0%;
        height:1px;

        background: currentColor;

        transition: width .3s ease;
    }

    &:hover::after{
        width:100%;
    }

    @media(max-width:700px){
        font-size:.82rem;
        letter-spacing:1px;
    }
`;

const properties = [
    {
        id: 7,
        image: grundKochelZusammen,
        title: "Grundstück in Kochel",
        text: "Attraktives Grundstück in begehrter Lage."
    },
    {
        id: 2,
        image: kochel,
        title: "Wohnhaus in Kochel",
        text: "Hochwertige Immobilie mit besonderem Charme."
    },
    {
        id: 11,
        image: kaffeemuehlenVilla,
        title: "Kaffeemühlen-Villa",
        text: "Villa auf 5.237 m² Parkgrundstück"
    },
    {
        id: 4,
        image: benediktbeuern,
        title: "Benediktbeuern",
        text: "Exklusive Immobilie im Voralpenland."
    },
    {
        id: 5,
        image: wohnung,
        title: "Eigentumswohnung",
        text: "Hochwertige Wohnung mit hervorragender Ausstattung."
    },
    {
        id: 6,
        image: laax,
        title: "Laax",
        text: "Alpine Immobilie in traumhafter Umgebung."
    }
];

function StartPage() {

    const navigate = useNavigate();

    const [videoLoaded, setVideoLoaded] = useState(false);

    useEffect(() => {
        const video = document.createElement("video");
        video.src = heroVideo;
        video.preload = "auto";
    }, []);

    return (
        <Content>
            <Hero>
    <HeroVideo
        autoPlay
        muted
        loop
        playsInline
        poster={chiemgau}
        onLoadedData={() => setVideoLoaded(true)}
        style={{
            opacity: videoLoaded ? 1 : 0,
            transition: "opacity 0.8s ease"
        }}
    >
        <source src={heroVideo} type="video/mp4" />
    </HeroVideo>

    <Overlay />

    <HeroContent>
        <HeroTitle>
            Ihr Makler für exklusive Immobilien in Oberbayern
        </HeroTitle>
    </HeroContent>
</Hero>

            <AboutSection>
                <Wrapper>
                    <SectionTitle>Über Uns</SectionTitle>

                    <AboutText>
                        <p>
                            Ob Sie eine Immobilie kaufen oder verkaufen möchten,
                            wir begleiten Sie während des gesamten Prozesses –
                            von der ersten Beratung bis zum
                            Eigentumsübergang.
                        </p>
                        <p>
                            Mit über 15 Jahren Erfahrung auf dem
                            oberbayerischen Immobilienmarkt verbinden wir
                            fundierte Marktkenntnis mit persönlicher Betreuung.
                            Als unabhängiges Familienunternehmen legen wir
                            besonderen Wert auf Vertrauen, Transparenz und eine
                            individuelle Beratung.
                        </p>

                        <p>
                            Unser Ziel ist es, Käufer und Verkäufer erfolgreich
                            zusammenzubringen und Sie bei jedem Schritt
                            kompetent zu begleiten. Wir freuen uns darauf, auch
                            für Sie der zuverlässige Immobilienpartner Ihres
                            Vertrauens zu sein.
                        </p>
                    </AboutText>
                </Wrapper>
            </AboutSection>

            <Section>
                <Wrapper>
                    <SectionTitle>Unsere Immobilien</SectionTitle>

                    <PropertyGrid>
                        {properties.map((property) => (
                            <PropertyCard
                                key={property.id}
                                onClick={() => {
                                    navigate(`/immobilie/${property.id}`);
                                }}
                            >
                                <ImageWrapper>
                                    <PropertyImage
                                        src={property.image}
                                        alt={property.title}
                                    />
                                </ImageWrapper>

                                <CardContent>
                                    <CardTitle>
                                        {property.title}
                                    </CardTitle>

                                    <CardText>
                                        {property.text}
                                    </CardText>
                                </CardContent>
                            </PropertyCard>
                        ))}
                    </PropertyGrid>

                    <CTAWrapper>
                        <CTAStyledLink
                        to="/immobilien"
                        $scrolled={true}
                    >
                        Alle Immobilien
                    </CTAStyledLink>
                    </CTAWrapper>
                </Wrapper>
            </Section>
        </Content>
    );
}

export default StartPage;

